import { Link } from 'react-router-dom';

const SHORT_ID_LENGTH = 8;

export const KvalitetSessionLink = ({
  sessionId,
  newTab = false,
}: {
  sessionId: string;
  newTab?: boolean;
}) => (
  <Link
    to={`/sessions?session=${encodeURIComponent(sessionId)}`}
    title={sessionId}
    target={newTab ? '_blank' : undefined}
    rel={newTab ? 'noopener noreferrer' : undefined}
    className="font-mono text-xs font-medium text-blue-700 hover:underline"
  >
    {sessionId.slice(0, SHORT_ID_LENGTH)}
  </Link>
);
